import CrudBaseService from "@/services/CrudBaseService";

export default class ShareModelService extends CrudBaseService {
  constructor() {
    super('insurance_pricing/share_models');
  }

  findAllByParams(data) {
    return this.http.get(`${this._serviceName}/findAllByParams`, { params: data });
  }

  getRevision(id) {
    return this.http.get(`${this._serviceName}/${id}/revision`);
  }
}
